exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".below-title-post-count{bottom:0!important;left:0}", ""]);

// exports
